<template>
  <div class="audio-timeline" ref="timeline" @click="handleClick">
    <div class="timeline__track">
      <div ref="playhead" class="timeline__playhead"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class AudioTimeline extends Vue {
  @Prop({ type: Number, required: true }) readonly currentTime!: number;
  @Prop({ type: Number, required: true }) readonly duration!: number;

  get playheadEl(): HTMLDivElement {
    return this.$refs.playhead as HTMLDivElement;
  }

  get timelineEl(): HTMLDivElement {
    return this.$refs.timeline as HTMLDivElement;
  }

  get timelineWidth(): number {
    return this.timelineEl.offsetWidth - this.playheadEl.offsetWidth;
  }

  mounted() {
    this.updatePlayhead();
  }

  @Watch('currentTime')
  onCurrentTimeChange() {
    this.updatePlayhead();
  }

  updatePlayhead() {
    if (!this.duration || !this.playheadEl || !this.timelineEl) return;
    const playPercent = this.currentTime / this.duration;
    this.playheadEl.style.marginLeft = this.timelineWidth * playPercent + 'px';
  }

  handleClick(event: MouseEvent) {
    const clickPercent = this.getClickPercent(event);
    this.$emit('seek', clickPercent);
  }

  getClickPercent(event: MouseEvent): number {
    const position = this.timelineEl.getBoundingClientRect().left;
    return (event.clientX - position) / this.timelineWidth;
  }
}
</script>

<style lang="scss" scoped>
.audio-timeline {
  cursor: pointer;

  .timeline__track {
    height: 4px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    position: relative;
    overflow: visible;

    &:hover .timeline__playhead {
      transform: scale(1.2);
    }
  }

  .timeline__playhead {
    width: 12px;
    height: 12px;
    background: $color-theme-red;
    border-radius: 50%;
    position: relative;
    top: -4px;
    transition: transform 0.2s;
    box-shadow: 0 0 6px rgba($color-theme-red, 0.5);
  }
}
</style>
